// src/utils/teamTiers.js
// Opponent strength tiers the coaches use (Tier column on the home page, "vs Tier 1" in charts).

export const PRIORITY_TEAMS = ["EA", "BAC", "BRU", "TLN"];

export const TEAM_TIER_MAP = {
  BAC: 1, BRU: 1, EA: 1, FS: 1, FW: 1,
  ANK: 2, BMG: 2, DCG: 2, FPT: 2, HKA: 2, ONE: 2, SGP: 2, TALONA: 2, TLN: 2,
  "1S": 3, KOG: 3, PSG: 3, TDT: 3,
  BACD: 4, BOX: 4, BSS: 4, CMES: 4, FPL: 4, FZ: 4, HD: 4, "Old Man's": 4, RK7: 4, SPN: 4,
};

export const tierOf = (team) => TEAM_TIER_MAP[String(team || "").trim()] ?? null;
